export const getInterventionIdentifier = (intervention) =>
  intervention?.publicId || intervention?.id;

export const getInterventionPath = (intervention) => {
  const identifier = getInterventionIdentifier(intervention);
  return identifier
    ? `/intervention/${encodeURIComponent(identifier)}`
    : "/interventions";
};

export const getNotificationInterventionIdentifier = (notification) =>
  notification?.publicId ||
  notification?.Intervention?.publicId ||
  notification?.notifiableId;
